import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap'
import ElementForm from '../ElementForm'

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func,
  parentId: PropTypes.number.isRequired,
  element: PropTypes.object,
  companiesData: PropTypes.array.isRequired
}

const defaultProps = {
  element: {},
}

const ElementModal = ({isOpen, onClose, onSaved, parentId, element, companiesData}) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>{element.id ? 'Edit element' : 'Add new element'}</ModalHeader>
      <ModalBody>
        <ElementForm
          element={element}
          inModal={true}
          companiesData={companiesData}
          parentId={parentId}
          onSubmit={onClose}
          onSaved={onSaved}
          onClose={onClose}
        />
      </ModalBody>
    </Modal>
  )
}

ElementModal.propTypes = propTypes
ElementModal.defaultProps = defaultProps

export default ElementModal



// WEBPACK FOOTER //
// ./src/components/Projects/helpers/ElementModal.js